import React, { useCallback, useEffect, useState } from 'react'
import ContainerLayout from '../../../../components/container-layout/ContainerLayout'
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom'
import { useLocation, useNavigate } from 'react-router-dom'
import { Box, Button, Chip } from '@mui/material'
import { advance_search, ELibraryFrontApi } from '../../../../api/e-library/e_library_front.api'
import StateComponents from '../../../../components/state-component/StateComponents'
import { ELibraryCategory, language_library_data, media_type_data_category } from '../../enum/elibrary_enum'
import { produce } from 'immer'
import SearchIcon from '@mui/icons-material/Search';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { library_type_list, LibraryTypeApi } from '../../../../api/library-type/library_type.api'
import { debouncedApiCall } from '../../../../utils/app.utils'
import { library_author_list, LibraryAuthorApi } from '../../../../api/library-author/library_author.api'
import moment from 'moment'
import BookLikeList from '../books/element/BookCard'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../store/store'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import Hashids from 'hashids'
import { routeName } from '../../../../routes/routeName'
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice'

type Props = {}

type search_type = {
    search_word: string;
    type: string[]
}
const ELibrarySearchGlobal = (props: Props) => {
    const location = useLocation();
    const pathname = location.pathname;
    const base_api = useSelector((state: RootState) => state.api.image_api);
    const hash_ids = new Hashids(process.env.REACT_APP_SECRET_SALT, 50);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [key_search, set_key_search] = useState<number>(1);
    const [start_date, set_start_date] = useState<string>("");
    const [end_date, set_end_date] = useState<string>("");
    const [language, set_language] = useState<{ value: string, label: string } | null>(null);
    const [library_type, set_library_type] = useState<any[]>([]);
    const [search_library_type, set_search_library_type] = useState<string>("");
    const [id_library_type, set_id_library_type] = useState<any[]>([]);
    const [publisher, set_publisher] = useState<any[]>([]);
    const [id_publisher, set_id_publisher] = useState<any[]>([]);
    const [search_publisher, set_search_publisher] = useState<string>("");

    const [book_data, set_book_data] = useState<any[]>([]);
    const [e_book_data, set_e_book_data] = useState<any[]>([]);
    const [audio_book_data, set_audio_book_data] = useState<any[]>([]);
    const [video_data, set_video_data] = useState<any[]>([]);
    const [podcast_data, set_podcast_data] = useState<any[]>([]);
    const [magazine_data, set_magazine_data] = useState<any[]>([]);
    const [thesis_data, set_thesis_data] = useState<any[]>([]);


    const [search_option, set_search_option] = useState<search_type[]>([
        {
            search_word: "",
            type: []
        }
    ])

    const handleChangeSearch = (index: number, field: keyof search_type, value: any) => {
        set_search_option((prev) =>
            produce(prev, (draft) => {
                draft[index][field] = value;
            })
        );
    };
    const handleAddRow = () => {
        const newRow: search_type = {
            search_word: "",
            type: []
        }
        set_search_option((prev) => ([...prev, newRow]))
    }

    const handleGetLibraryType = useCallback(async () => {
        let query: library_type_list = {
            page: 1,
            limit: 30,
        }
        if (search_library_type) query.search = search_library_type
        await LibraryTypeApi.list(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                set_library_type(response);
            }
        }).catch((err) => {
            console.log(err)
        })
    }, [search_library_type])
    const handleGetLibraryPublisher = useCallback(async () => {
        let query: library_author_list = {
            page: 1,
            limit: 30,
        }
        if (search_publisher) query.search = search_publisher
        await LibraryAuthorApi.list(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                set_publisher(response);
            }
        }).catch((err) => {
            console.log(err)
        })
    }, [search_publisher])



    const handleGetData = async (clear?: boolean) => {
        let body: advance_search = {
            start_date: start_date ? moment(start_date).format("YYYY-MM-DD") : null,
            end_date: end_date ? moment(end_date).format("YYYY-MM-DD") : null,
            id_library_author_publishers: id_publisher?.map((list) => list?.id_library_author),
            id_library_types: id_library_type?.map((list: any) => list?.id_library_type),
            language: language?.value || null,
            search: search_option?.map((list) => {
                return {
                    search_word: list.search_word,
                    type: list?.type?.length === 0 ? media_type_data_category?.map((x) => x.value) : list.type?.map((x: any) => x.value)
                }
            })
        }
        if (clear) {
            body.start_date = null;
            body.end_date = null;
            body.search = [];
            body.language = "";
            body.id_library_author_publishers = [];
            body.id_library_types = [];

            set_id_library_type([]);
            set_id_publisher([]);
            set_start_date("");
            set_end_date("");
            set_key_search((prev) => prev + 1);
            set_language(null);
            set_search_option([{ search_word: "", type: [] }])
        }
        dispatch(setLoading());
        await ELibraryFrontApi.advanceSearch(body).then((res) => {
            if (res.status < 300) {
                if (clear) {
                    set_audio_book_data([]);
                    set_book_data([]);
                    set_video_data([]);
                    set_podcast_data([]);
                    set_e_book_data([]);
                    set_thesis_data([]);
                    set_magazine_data([]);
                } else {
                    const response: any[] = res.data?.data || [];
                    const book_response = response?.filter((x) => x.library_category_name === ELibraryCategory.BOOK);
                    const audio_book_response = response?.filter((x) => x.library_category_name === ELibraryCategory.AUDIO_BOOK);
                    const video_response = response?.filter((x) => x.library_category_name === ELibraryCategory.VIDEO);
                    const podcast_response = response?.filter((x) => x.library_category_name === ELibraryCategory.PODCAST);
                    const e_book_response = response?.filter((x) => x.library_category_name === ELibraryCategory.E_BOOK);
                    const thesis_response = response?.filter((x) => x.library_category_name === ELibraryCategory.THESIS);
                    const magazine_response = response?.filter((x) => x.library_category_name === ELibraryCategory.MAGAZINE);
                    set_magazine_data(magazine_response);
                    set_audio_book_data(audio_book_response);
                    set_book_data(book_response);
                    set_video_data(video_response);
                    set_podcast_data(podcast_response);
                    set_e_book_data(e_book_response);
                    set_thesis_data(thesis_response)
                }
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }


    useEffect(() => {
        handleGetLibraryType();
    }, [handleGetLibraryType])
    useEffect(() => {
        handleGetLibraryPublisher();
    }, [handleGetLibraryPublisher])
    return (
        <ContainerLayout
            navigateContent={
                <NavigateListCustom
                    navigateData={[
                        { key: 'จัดการข้อมูล E-Library', name: 'จัดการข้อมูล E-Library', pathName: "", disabled_match: true },
                        {
                            key: 'A',
                            name: "การสืบค้นขั้นสูง",
                            pathName: pathname
                        },
                    ]}
                />
            }
            title='การสืบค้นขั้นสูง'
            content={
                <Box>
                    {search_option?.map((list, i) => {
                        return (
                            <Box
                                key={`key_${i + 1}`}
                            >
                                <StateComponents
                                    otherProps={{ spacing: 2 }}
                                    typeProps={[
                                        {
                                            seq: 1,
                                            gridProps: {
                                                xs: 12,
                                                md: 6
                                            },
                                            type: "TEXT_FIELD",
                                            fieldProps: {
                                                heading: "ค้นคำ",
                                                key: key_search,
                                                placeholder: 'ระบุ',
                                                onChange: (e) => handleChangeSearch(i, 'search_word', e.target.value)
                                            }
                                        },
                                        {
                                            seq: 2,
                                            gridProps: {
                                                xs: 12,
                                                md: 6
                                            },
                                            type: "AUTO-COMPLETE",
                                            fieldProps: {
                                                getOptionLabel: (op) => op?.name,
                                                labelId: "type",
                                                heading: 'ประเภท',
                                                onChange: (_, val) => {
                                                    handleChangeSearch(i, 'type', val ?? []);
                                                },
                                                limitTags: 1000,
                                                multiple: true,
                                                placeholder: list.type?.length === 0 ? "ระบุ" : undefined,
                                                disableCloseOnSelect: true,
                                                isOptionEqualToValue: (option: any, value: any) => option.value === value.value,
                                                renderTags: (value: any[], getTagProps: any) => {
                                                    return value?.map((option, index) => (
                                                        <Chip
                                                            variant="outlined"
                                                            label={option?.name}
                                                            {...getTagProps({ index })}
                                                        />
                                                    ))
                                                },
                                                options: media_type_data_category || [],
                                                value: list.type || []
                                            }
                                        },
                                    ]}
                                />
                                {(search_option?.length - 1 == i) && (
                                    <Box my={2} className="flex justify-end items-center">
                                        <button onClick={handleAddRow} className='text-green-400'>+ เพิ่มคำค้น</button>
                                    </Box>
                                )}
                            </Box>
                        )
                    })}


                    <Box my={2}>
                        <StateComponents
                            otherProps={{ spacing: 2 }}
                            heading='ตัวเลือกการสืบค้น'
                            typeProps={[
                                {
                                    seq: 1,
                                    type: "AUTO-COMPLETE",
                                    fieldProps: {
                                        getOptionLabel: (op) => op?.library_type_name || "",
                                        labelId: "12",
                                        options: library_type || [],
                                        value: id_library_type || [],
                                        onInputChange: (_: any, val: string) => debouncedApiCall({ searchItem: val, setItem: set_search_library_type }),
                                        onChange: (_, val) => set_id_library_type(val ?? []),
                                        limitTags: 1000,
                                        multiple: true,
                                        heading: "หมวดหมู่",
                                        placeholder: id_library_type?.length === 0 ? "ระบุ" : undefined,
                                        disableCloseOnSelect: true,
                                        isOptionEqualToValue: (option: any, value: any) => option.id_library_type === value.id_library_type,
                                        renderTags: (value: any[], getTagProps: any) => {
                                            return value?.map((option, index) => (
                                                <Chip
                                                    variant="outlined"
                                                    label={option?.library_type_name}
                                                    {...getTagProps({ index })}
                                                />
                                            ))
                                        },
                                    },
                                    gridProps: {
                                        xs: 12
                                    }
                                },
                                {
                                    seq: 2,
                                    type: "AUTO-COMPLETE",
                                    fieldProps: {
                                        getOptionLabel: (op) => op?.library_author_name || "",
                                        labelId: "dd",
                                        onChange: (_, val) => set_id_publisher(val ?? []),
                                        options: publisher,
                                        value: id_publisher || [],
                                        heading: 'สำนักพิมพ์ หรือ สังกัด',
                                        limitTags: 1000,
                                        multiple: true,
                                        placeholder: id_publisher?.length === 0 ? "ระบุ" : undefined,
                                        disableCloseOnSelect: true,
                                        isOptionEqualToValue: (option: any, value: any) => option.id_library_author === value.id_library_author,
                                        renderTags: (value: any[], getTagProps: any) => {
                                            return value?.map((option, index) => (
                                                <Chip
                                                    variant="outlined"
                                                    label={option?.library_author_name}
                                                    {...getTagProps({ index })}
                                                />
                                            ))
                                        },
                                    },
                                    gridProps: {
                                        xs: 12
                                    }
                                },
                                {
                                    seq: 3,
                                    type: "AUTO-COMPLETE",
                                    fieldProps: {
                                        heading: 'ภาษา',
                                        getOptionLabel: (op) => op?.label || "",
                                        labelId: "language",
                                        placeholder: "ระบุ",
                                        onChange: (_, val) => set_language(val),
                                        options: language_library_data,
                                        value: language || null
                                    },
                                    gridProps: {
                                        xs: 12
                                    }
                                },
                                {
                                    seq: 4,
                                    type: "DATE",
                                    fieldProps: {
                                        heading: 'วันที่เริ่มต้น',
                                        placeholder: "ระบุ",
                                        onChange: (date) => set_start_date(date),
                                        disableEndDate: end_date,
                                        value: start_date
                                    },
                                    gridProps: {
                                        xs: 12,
                                        md: 6
                                    }
                                },
                                {
                                    seq: 5,
                                    type: "DATE",
                                    fieldProps: {
                                        heading: 'วันที่สิ้นสุด',
                                        placeholder: "ระบุ",
                                        disableStartDate: start_date,
                                        onChange: (date) => set_end_date(date),
                                        value: end_date
                                    },
                                    gridProps: {
                                        xs: 12,
                                        md: 6
                                    }
                                },
                            ]}
                        />

                        <Box my={4} className="w-full flex flex-col md:flex-row justify-center items-center gap-5">
                            <Button onClick={() => handleGetData(true)} startIcon={<DeleteForeverIcon />} fullWidth color='error' variant='contained'>ล้างค่า</Button>
                            <Button onClick={() => handleGetData()} startIcon={<SearchIcon />} fullWidth color='success' variant='contained'>ค้นหา</Button>
                        </Box>
                    </Box>


                    <Box className="flex flex-col gap-7">
                        {book_data?.length > 0 && (
                            <BookLikeList
                                title='หนังสือ'
                                baseApi={base_api}
                                onCancel={() => { }}
                                hidden_button={true}
                                dataLike={book_data?.map((list) => {
                                    const encode_id = hash_ids.encode(String(list.id_library_head || ""));
                                    return {
                                        file_name: list?.file_name,
                                        file_path: list?.file_path,
                                        id: list?.id_library_head,
                                        library_author_by: list?.library_author_by,
                                        library_head_name: list?.library_head_name,
                                        other_content: () => (
                                            <Box>
                                                <Button
                                                    onClick={() => navigate(routeName.e_library.books_detail.replace(":id", encode_id))}
                                                    startIcon={<VisibilityOutlinedIcon />}
                                                    sx={{ borderRadius: "8px" }}
                                                    variant='outlined'>
                                                    ดู
                                                </Button>
                                            </Box>
                                        )
                                    }
                                })}
                            />
                        )}
                        {e_book_data?.length > 0 && (
                            <BookLikeList
                                title='E-book'
                                baseApi={base_api}
                                onCancel={() => { }}
                                hidden_button={true}
                                dataLike={e_book_data?.map((list) => {
                                    const encode_id = hash_ids.encode(String(list.id_library_head || ""));
                                    return {
                                        file_name: list?.file_name,
                                        file_path: list?.file_path,
                                        id: list?.id_library_head,
                                        library_author_by: list?.library_author_by,
                                        library_head_name: list?.library_head_name,
                                        other_content: () => (
                                            <Box>
                                                <Button
                                                    onClick={() => navigate(routeName.e_library.e_books_detail.replace(":id", encode_id))}
                                                    startIcon={<VisibilityOutlinedIcon />}
                                                    sx={{ borderRadius: "8px" }}
                                                    variant='outlined'>
                                                    ดู
                                                </Button>
                                            </Box>
                                        )
                                    }
                                })}
                            />
                        )}
                        {audio_book_data?.length > 0 && (
                            <BookLikeList
                                title='หนังสือเสียง'
                                baseApi={base_api}
                                onCancel={() => { }}
                                hidden_button={true}
                                dataLike={audio_book_data?.map((list) => {
                                    const encode_id = hash_ids.encode(String(list.id_library_head || ""));
                                    return {
                                        file_name: list?.file_name,
                                        file_path: list?.file_path,
                                        id: list?.id_library_head,
                                        library_author_by: list?.library_author_by,
                                        library_head_name: list?.library_head_name,
                                        other_content: () => (
                                            <Box>
                                                <Button
                                                    onClick={() => navigate(routeName.e_library.audio_book_detail.replace(":id", encode_id))}
                                                    startIcon={<VisibilityOutlinedIcon />}
                                                    sx={{ borderRadius: "8px" }}
                                                    variant='outlined'>
                                                    ดู
                                                </Button>
                                            </Box>
                                        )
                                    }
                                })}
                            />
                        )}
                        {magazine_data?.length > 0 && (
                            <BookLikeList
                                title='วารสาร'
                                baseApi={base_api}
                                onCancel={() => { }}
                                hidden_button={true}
                                dataLike={magazine_data?.map((list) => {
                                    const encode_id = hash_ids.encode(String(list.id_library_head || ""));
                                    return {
                                        file_name: list?.file_name,
                                        file_path: list?.file_path,
                                        id: list?.id_library_head,
                                        library_author_by: list?.library_author_by,
                                        library_head_name: list?.library_head_name,
                                        other_content: () => (
                                            <Box>
                                                <Button
                                                    onClick={() => navigate(routeName.e_library.journal_detail.replace(":id", encode_id))}
                                                    startIcon={<VisibilityOutlinedIcon />}
                                                    sx={{ borderRadius: "8px" }}
                                                    variant='outlined'>
                                                    ดู
                                                </Button>
                                            </Box>
                                        )
                                    }
                                })}
                            />
                        )}
                        {thesis_data?.length > 0 && (
                            <BookLikeList
                                title='วิทยานิพนธ์'
                                baseApi={base_api}
                                onCancel={() => { }}
                                hidden_button={true}
                                dataLike={thesis_data?.map((list) => {
                                    const encode_id = hash_ids.encode(String(list.id_library_head || ""));
                                    return {
                                        file_name: list?.file_name,
                                        file_path: list?.file_path,
                                        id: list?.id_library_head,
                                        library_author_by: list?.library_author_by,
                                        library_head_name: list?.library_head_name,
                                        other_content: () => (
                                            <Box>
                                                <Button
                                                    onClick={() => navigate(routeName.e_library.journal_detail.replace(":id", encode_id))}
                                                    startIcon={<VisibilityOutlinedIcon />}
                                                    sx={{ borderRadius: "8px" }}
                                                    variant='outlined'>
                                                    ดู
                                                </Button>
                                            </Box>
                                        )
                                    }
                                })}
                            />
                        )}
                        {podcast_data?.length > 0 && (
                            <BookLikeList
                                title='พอดแคสต์'
                                baseApi={base_api}
                                onCancel={() => { }}
                                hidden_button={true}
                                dataLike={podcast_data?.map((list) => {
                                    const encode_id = hash_ids.encode(String(list.id_library_head || ""));
                                    return {
                                        file_name: list?.file_name,
                                        file_path: list?.file_path,
                                        id: list?.id_library_head,
                                        library_author_by: list?.library_author_by,
                                        library_head_name: list?.library_head_name,
                                        other_content: () => (
                                            <Box>
                                                <Button
                                                    onClick={() => navigate(routeName.e_library.podcast_detail.replace(":id", encode_id))}
                                                    startIcon={<VisibilityOutlinedIcon />}
                                                    sx={{ borderRadius: "8px" }}
                                                    variant='outlined'>
                                                    ดู
                                                </Button>
                                            </Box>
                                        )
                                    }
                                })}
                            />
                        )}
                        {video_data?.length > 0 && (
                            <BookLikeList
                                title='วีดีโอ'
                                baseApi={base_api}
                                onCancel={() => { }}
                                hidden_button={true}
                                dataLike={video_data?.map((list) => {
                                    const encode_id = hash_ids.encode(String(list.id_library_head || ""));
                                    return {
                                        file_name: list?.file_name,
                                        file_path: list?.file_path,
                                        id: list?.id_library_head,
                                        library_author_by: list?.library_author_by,
                                        library_head_name: list?.library_head_name,
                                        other_content: () => (
                                            <Box>
                                                <Button
                                                    onClick={() => navigate(routeName.e_library.video_detail.replace(":id", encode_id))}
                                                    startIcon={<VisibilityOutlinedIcon />}
                                                    sx={{ borderRadius: "8px" }}
                                                    variant='outlined'>
                                                    ดู
                                                </Button>
                                            </Box>
                                        )
                                    }
                                })}
                            />
                        )}
                    </Box>
                </Box>
            }
        />
    )
}

export default ELibrarySearchGlobal